<template>
  <div id="app" class="flex flex-col min-h-screen">
  <div
      class="relative flex flex-wrap items-start flex-auto w-full max-w-full p-5 mx-auto bg-gray-100 md:flex-no-wrap md:p-6"
    >
      <the-sidebar class="pt-6 md:pt-0 the-sidebar" />
      <the-main class="flex flex-col self-stretch sm:ml-8 md:pt-4"></the-main>
    </div>
    <language-dropdown />
    <footer
      class="flex flex-col px-6 py-4 text-sm text-center text-gray-600 md:flex-row md:justify-end md:text-left"
    >
      <div class="mr-4">
        © <span v-html="new Date().getFullYear()" /> Ravensberger
        Schmierstoffvertrieb GmbH
      </div>
      <nav class="space-x-3">
        <a
          href="https://www.ravenol.de/en/conditions/"
          target="_blank"
          rel="noopener"
          >{{ $t("footer.conditions") }}</a
        >
        <a
          href="https://www.ravenol.de/en/privacy/"
          target="_blank"
          rel="noopener"
          >{{ $t("footer.privacy") }}</a
        >
        <a
          href="https://www.ravenol.de/en/imprint/"
          target="_blank"
          rel="noopener"
          >{{ $t("footer.imprint") }}</a
        >
      </nav>
    </footer>
  </div>
</template>

<script>
import TheSidebar from '@/components/TheSidebar.vue';
import TheMain from '@/components/TheMain.vue';
import LanguageDropdown from '@/components/LanguageDropdown.vue';
import i18n from '@/i18n';

export default {
  name: 'App',
  components: {
    TheSidebar,
    TheMain,
    LanguageDropdown
  },
  methods: {
    getHrefLanguages () {
      return i18n.availableLocales.map(lang => (
        {
          rel: 'alternate', href: `${location.origin}?lang=${lang}`, hreflang: lang
        }
      ));
    }
  },
  metaInfo () {
    return {
      title: `Ravenol ${this.$t('common.Oilfinder')}`,
      titleTemplate: '%s | Ravensberger Schmierstoffvertrieb GmbH',
      meta: [
        { name: 'description', content: this.$t('meta.description') },
        { property: 'og:title', content: `Ravenol ${this.$t('common.Oilfinder')}` },
        { property: 'og:site_name', content: `Ravenol ${this.$t('common.Oilfinder')} | Ravensberger Schmierstoffvertrieb GmbH | Ravenol` },
        { property: 'og:url', content: location.origin },
        { property: 'og:description', content: this.$t('meta.description') },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: location.origin + require('@/assets/img/og_ravenol.jpg') }
      ],
      link: this.getHrefLanguages()
    };
  }
};
</script>

<style scoped lang="postcss">
#app {
  --sidebar-width: 100%;

  @screen md {
    --sidebar-width: 300px;
  }

  @screen lg {
    --sidebar-width: 390px;
  }
  overflow-x: hidden;
}

.the-sidebar {
  flex: 0 0 var(--sidebar-width);
  max-width: var(--sidebar-width);
}
</style>
